import React from 'react';

// ==================== NEW ZEALAND PAGE ====================
const NewZealandPage = ({ onBack }) => {
    return (
        <div className="newzealand-page">
            {/* Hero Section */}
            <section
                className="hero-section relative overflow-hidden min-h-screen flex items-center justify-center"
                style={{
                    backgroundImage: "url('https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=3840&q=95')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                <div className="absolute inset-0 z-0">
                    <div
                        className="absolute inset-0 full-bg-section"
                        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=3840&q=95')" }}
                    />
                </div>
                <div className="hero-overlay absolute inset-0 z-10"></div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 md:pt-36 pb-16 w-full relative z-20">
                    <div className="text-white text-center">
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
                            Study in New Zealand - Expert Guidance from Hyderabad
                        </h1>
                        <p className="text-xl md:text-2xl mb-4 text-primary-red font-semibold">
                            Trusted New Zealand Consultants | High Visa Success Rate
                        </p>
                        <p className="text-lg md:text-xl mb-8 text-gray-100 leading-relaxed max-w-3xl mx-auto">
                            Start your journey to world-class education in New Zealand with Swan Global. We provide complete support from admission to visa approval.
                        </p>
                        <div className="hero-buttons flex flex-wrap gap-4 justify-center">
<a
                                href="mailto:info@swanglobaledu.com?subject=Book%20Free%20Consultation%20for%20New%20Zealand"
                                className="btn-primary inline-flex items-center gap-2"
                            >
                                <i className="fas fa-calendar-check"></i>
                                Book FREE Consultation
                            </a>
                            <a
                                href="https://wa.me/919000329999"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-secondary inline-flex items-center gap-2"
                            >
                                <i className="fab fa-whatsapp"></i>
                                WhatsApp Now (+91-9000329999)
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Study in New Zealand */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Why Choose New Zealand?</h2>
                        <p className="text-xl text-primary-red font-semibold">
                            New Zealand offers the perfect balance of education, career, and lifestyle.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
                        {[
                            { icon: 'fa-graduation-cap', title: 'Globally recognized universities' },
                            { icon: 'fa-shield-alt', title: 'Safe and student-friendly environment' },
                            { icon: 'fa-briefcase', title: 'Post-study work opportunities' },
                            { icon: 'fa-globe', title: 'High quality of life' },
                            { icon: 'fa-road', title: 'PR (Permanent Residency) pathways' },
                        ].map((item, index) => (
                            <div key={index} className="bg-lightGray p-6 rounded-2xl text-center">
                                <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                                    <i className={`fas ${item.icon} text-white text-2xl`}></i>
                                </div>
                                <p className="text-black font-medium">{item.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Swan Global for New Zealand */}
            <section className="py-20 bg-lightGray">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Best New Zealand Consultant in Hyderabad</h2>
                        <p className="text-xl text-primary-red font-semibold max-w-4xl mx-auto">
                            At Swan Global, we specialize in New Zealand education and have successfully guided hundreds of students.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
                        {[
                            'High visa success rate',
                            'Expert counseling',
                            'Personalized university selection',
                            'End-to-end support',
                            'Strong experience in NZ applications',
                        ].map((point, index) => (
                            <div key={index} className="bg-white p-6 rounded-2xl text-center shadow-lg">
                                <div className="w-10 h-10 bg-primary-red rounded-full flex items-center justify-center text-white mx-auto mb-4">
                                    <i className="fas fa-check"></i>
                                </div>
                                <p className="text-black font-medium">{point}</p>
                            </div>
                        ))}
                    </div>

                    <p className="text-center text-primary-red font-semibold text-xl mt-10">
                        Your trusted partner for New Zealand education
                    </p>
                </div>
            </section>

            {/* Services */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Complete Support for Your NZ Journey</h2>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[
                            { icon: 'fa-user-graduate', title: 'Career Counseling' },
                            { icon: 'fa-university', title: 'University & Course Selection' },
                            { icon: 'fa-file-alt', title: 'SOP & Documentation Support' },
                            { icon: 'fa-money-check-alt', title: 'Education Loan Assistance' },
                            { icon: 'fa-passport', title: 'Visa Filing & Interview Prep' },
                            { icon: 'fa-plane-departure', title: 'Pre-Departure Guidance' },
                        ].map((service, index) => (
                            <div key={index} className="bg-lightGray p-8 rounded-2xl text-center">
                                <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                                    <i className={`fas ${service.icon} text-white text-2xl`}></i>
                                </div>
                                <h3 className="text-xl font-semibold text-black">{service.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Process */}
            <section className="py-20 bg-lightGray">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Simple Process to Study in New Zealand</h2>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { step: '1', title: 'Free Consultation' },
                            { step: '2', title: 'Profile Evaluation' },
                            { step: '3', title: 'Course & University Selection' },
                            { step: '4', title: 'Application Submission' },
                            { step: '5', title: 'SOP & Documentation' },
                            { step: '6', title: 'Visa Filing' },
                            { step: '7', title: 'Fly to New Zealand' },
                        ].map((item, index) => (
                            <div key={index} className="bg-white p-6 rounded-2xl text-center">
                                <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">
                                    {item.step}
                                </div>
                                <p className="text-black font-medium">{item.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Success Section */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Our New Zealand Success</h2>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8 text-center">
                        <div className="bg-lightGray p-8 rounded-2xl">
                            <span className="text-5xl font-extrabold text-primary-red block mb-2">Hundreds</span>
                            <span className="text-lg text-black">Students Sent to NZ</span>
                        </div>
                        <div className="bg-lightGray p-8 rounded-2xl">
                            <span className="text-5xl font-extrabold text-primary-red block mb-2">High</span>
                            <span className="text-lg text-black">Visa Success Rate</span>
                        </div>
                        <div className="bg-lightGray p-8 rounded-2xl">
                            <span className="text-5xl font-extrabold text-primary-red block mb-2">Trusted</span>
                            <span className="text-lg text-black">by Hyderabad Students</span>
                        </div>
                    </div>
                    <p className="text-center text-gray mt-8">
                        Add real visa approvals / student photos here.
                    </p>
                </div>
            </section>

{/* Testimonials */}
            <section id="testimonials" className="py-20 bg-lightGray" style={{ minHeight: '50vh' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Student Success Stories</h2>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        {[
                            {
                                text: 'Thanks to Swan Global, I got my New Zealand visa smoothly. Highly recommended!',
                                name: 'Student Testimonial',
                                country: 'New Zealand',
                            },
                            {
                                text: 'Best consultancy in Hyderabad for New Zealand. Very supportive team.',
                                name: 'Student Testimonial',
                                country: 'New Zealand',
                            },
                        ].map((testimonial, index) => (
                            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg">
                                <div className="flex text-yellow-400 mb-4">
                                    {[...Array(5)].map((_, i) => (
                                        <i key={i} className="fas fa-star"></i>
                                    ))}
                                </div>
                                <p className="text-gray italic mb-6">"{testimonial.text}"</p>
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center text-white">
                                        <i className="fas fa-user"></i>
                                    </div>
                                    <div>
                                        <h4 className="text-lg font-semibold text-black">{testimonial.name}</h4>
                                        <span className="text-primary-red text-sm">{testimonial.country}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="text-center text-gray mt-8">
                        Add real photos for strong trust.
                    </p>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 bg-primary-red relative overflow-hidden">
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="absolute bottom-0 left-0 w-72 h-72 bg-white opacity-5 rounded-full translate-y-1/2 -translate-x-1/2"></div>

                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
                    <h2 className="text-4xl font-bold text-white mb-4">
                        Ready to Study in New Zealand?
                    </h2>
                    <p className="text-xl text-white/90 mb-6">
                        Get expert guidance from Hyderabad's trusted New Zealand consultants.
                    </p>
                    <p className="text-lg text-white/80 mb-8">
                        Limited FREE consultation slots available!
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
<a
                            href="mailto:info@swanglobaledu.com?subject=Book%20Free%20Consultation%20for%20New%20Zealand"
                            className="bg-white text-primary-red px-8 py-4 rounded-full font-semibold hover:bg-black hover:text-white transition-all duration-300 inline-flex items-center gap-2"
                        >
                            <i className="fas fa-calendar-check"></i>
                            Book Free Consultation
                        </a>
                        <a
                            href="https://wa.me/919000329999"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-transparent text-white border-2 border-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-primary-red transition-all duration-300 inline-flex items-center gap-2"
                        >
                            <i className="fab fa-whatsapp"></i>
                            WhatsApp Now
                        </a>
                    </div>
                </div>
            </section>

            {/* Contact Line + SEO keywords */}
            <section className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-lg text-gray mb-4">
                        613, 6th floor, Fairmount Downtown, Kompally, Secunderabad, Hyderabad, Telangana- 500100
                    </p>
                    <p className="text-sm text-gray-500 max-w-4xl mx-auto">
                        Study in New Zealand Hyderabad | New Zealand student visa Hyderabad | Best NZ consultants Hyderabad | New Zealand education consultants
                    </p>
                </div>
            </section>

            {/* Back Button */}
            <div className="fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50">
                <button
                    onClick={onBack}
                    className="bg-primary-red text-white px-4 md:px-6 py-2.5 md:py-3 rounded-full text-sm md:text-base font-semibold hover:bg-primary-dark transition-all duration-300 shadow-lg flex items-center gap-2"
                >
                    <i className="fas fa-arrow-left"></i>
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default NewZealandPage;

